import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Two-factor authentication (2FA)")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Send Two-factor authentication", -1)
const _hoisted_6 = { class: "row w-100" }
const _hoisted_7 = { class: "col-md-12 col-lg-12 my-1" }
const _hoisted_8 = { class: "row mt-2 w-100" }
const _hoisted_9 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-5 my-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_11 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-5 my-1" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "text-muted h5 font-weight-normal mr-3" }, "Flow", -1)
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" SMS ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Call ")
const _hoisted_17 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-2 mt-2" }
const _hoisted_18 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" SEND CODE ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Verify Code", -1)
const _hoisted_23 = { class: "row mt-2 w-100" }
const _hoisted_24 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-5 my-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert code without symbols (+, -, etc) or spaces ", -1)
const _hoisted_26 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-2 mt-2" }
const _hoisted_27 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Verify ")

import { ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { Form, FormActions, Field } from "vee-validate";
import { Promotion, Unlock } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dialerApi } from "@/conection/index";
import { formatNumber } from "@/util/utils.ts";
import swal from "sweetalert2";

import * as yup from "yup";

enum sendType {
	CALL = "call",
	SMS = "sms",
	WA = "wha",
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const radioType = ref("sms");

const loadingSend = ref(false);
const loadingVerify = ref(false);

function addBreaks(str: string): string {
	return str.split("").join(' <break time="1s" /> ');
}
function generateToken() {
	const randomNum = Math.random() * 9000;
	return Math.floor(1000 + randomNum);
}

//schema
const schema = yup.object({
	message: yup
		.string()
		.matches(
			/^[\w\s\p{P}\p{S}]+$/u,
			"Message is not valid, It should not contain accents."
		)
		.required("Message is required"),
	number1: yup.string().matches(/[0-9]{3,}/, "Phone number is not valid"),
});
const schemaCode = yup.object({
	code: yup.string().matches(/[0-9]{4}/, "Code is not valid"),
});
async function onSubmit(values: any) {
	switch (radioType.value) {
		case sendType.SMS:
			sendSMSCode(values);
			break;
		case sendType.CALL:
			sendCall(values);
			break;
		case sendType.WA:
			sendCall(values);
			break;
		default:
			break;
	}
}
async function sendSMSCode(values: any) {
	loadingSend.value = true;
	try {
		const token = generateToken() + "";
		localStorage.setItem("code", token);

		const response = await dialerApi.post("/vonage/sms", {
			from: "EMLABS2",
			to: values.number1,
			message: `${values.message}  ${token}`,
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Message sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Message has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Message has not been sent`,
			type: "error",
		});
	}

	loadingSend.value = false;
}
async function sendCall(values: any) {
	loadingSend.value = true;
	const token = generateToken() + "";
	localStorage.setItem("code", token);
	try {
		const response = await dialerApi.post("/dialer/send/notification", {
			to: {
				number: formatNumber(values.number1),
				context: "llamada_saliente_internacional",
			},
			text: `${values.message} ${addBreaks(token)}`,
			dtmf_options: {
				ttp: 5000,
				length: 2,
			},
			config: {
				repeat: 1,
				offsetms: 2000,
			},
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Call sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Call has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Call has not been sent`,
			type: "error",
		});
	}

	loadingSend.value = false;
}
async function verifyCode(values: any) {
	loadingSend.value = true;
	try {
		const localCode = localStorage.getItem("code");

		if (localCode === values?.code) {
			swal.fire({
				title: "Verify Code",
				text: "Code is valid!",
				icon: "success",
			});
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Code is valid`,
				type: "success",
			});
		} else {
			swal.fire({
				title: "Verify Code",
				text: "Code is invalid",
				icon: "error",
			});
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Code is invalid`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Validation code`,
			type: "error",
		});
	}

	loadingSend.value = false;
}

function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);

	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_base_radio = _resolveComponent("base-radio")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _hoisted_5,
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ handleSubmit, values }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(BaseInput, {
                        type: "textarea",
                        name: "message",
                        label: "Greeting",
                        placeholder: "This is your 2FA ",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        alternative: "",
                        inputGroupClasses: "w-100"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Phone number 1",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        inputGroupClasses: "w-75",
                        alternative: ""
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_base_radio, {
                            modelValue: radioType.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radioType).value = $event)),
                            name: "sms"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_base_radio, {
                            modelValue: radioType.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((radioType).value = $event)),
                            name: "call"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_base_button, {
                          disabled: loadingSend.value,
                          "native-type": "submit",
                          onClickCapture: ($event: any) => (handleSubmit($event, onSubmit(values)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              (!loadingSend.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Promotion))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingSend.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                : _createCommentVNode("", true),
                              _hoisted_21
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])),
              _hoisted_22,
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schemaCode),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ handleSubmit, values }) => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(BaseInput, {
                        name: "code",
                        label: "Code",
                        placeholder: "1234",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-lock",
                        inputGroupClasses: "w-75",
                        alternative: ""
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_base_button, {
                          disabled: loadingVerify.value,
                          "native-type": "submit",
                          onClickCapture: ($event: any) => (handleSubmit($event, verifyCode(values)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_28, [
                              (!loadingVerify.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Unlock))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingVerify.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                                : _createCommentVNode("", true),
                              _hoisted_30
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})